module.exports = __webpack_public_path__ + "static/media/icon_top.15206a96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_top.svg
// module id = 2422
// module chunks = 7